
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"52.079","height":"22.678"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 599","fill":"none"}},[_c('path',{attrs:{"data-name":"Path 6852","d":"M13.167 22.119a17.87 17.87 0 1135.739 0"}}),_c('path',{attrs:{"data-name":"Path 6853","d":"M15.018 14.198a5.841 5.841 0 014.686 5.726v2.2h5.493V19.93a5.84 5.84 0 0111.68 0v2.194h5.494v-2.2a5.841 5.841 0 014.686-5.726"}}),_c('path',{attrs:{"data-name":"Line 57","d":"M17.37 10.557h27.343"}}),_c('path',{attrs:{"data-name":"Line 58","d":"M16.164 12.194h29.744"}}),_c('path',{attrs:{"data-name":"Line 59","d":"M14.043 16.577h33.986"}}),_c('path',{attrs:{"data-name":"Path 6854","d":"M32.574 7.77a1.538 1.538 0 10-1.538 1.537 1.538 1.538 0 001.538-1.537z"}}),_c('path',{attrs:{"data-name":"Path 6855","d":"M15.255 5.465c3.757-3 9.43-4.91 15.782-4.91 11.313 0 20.487 6.068 20.487 13.558h-4.468"}}),_c('path',{attrs:{"data-name":"Path 6856","d":"M19.341 8.582H1.217l-.658 2.906h16.1"}}),_c('path',{attrs:{"data-name":"Path 6857","d":"M16.711 6.232H2.818l-.658 2.35h15.206z"}}),_c('path',{attrs:{"data-name":"Path 6858","d":"M14.594 3.934H4.939l-.658 2.349h10.972z"}}),_c('path',{attrs:{"data-name":"Path 6859","d":"M12.75 1.585H6.783l-.658 2.35h7.283z"}}),_c('path',{attrs:{"data-name":"Path 6860","d":"M2.163 11.486v10.632h11"}}),_c('path',{attrs:{"data-name":"Line 60","d":"M51.524 14.112v8.008"}})])])
          )
        }
      }
    